import React, { useContext, useEffect } from "react";
import { httpGet } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import { Environment } from "../utils/environments";
import { ThemeContext } from "../context/ThemeContext";
import { useNavigate } from "react-router-dom";

export default function useFetchSaleTickets() {
  const { getSaleTickets } = useContext(ThemeContext);
  const [saleTickets, setSaleTickets] = getSaleTickets;

  const navigate = useNavigate();

  /**
   * Fetch sale tickets for support products
   */
  const fetchSaleTickets = async () => {
    try {
      await httpGet({
        pathName: "nowonsale-products",
        queryParams: { productType: "SUPPORT" },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        if (Environment.getBuildType() != "prod") {
          console.log(data);
        }
        setSaleTickets(data.productList);
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      navigate(`/error?code=${error.response?.status}`);
    }
  };

  return { saleTickets, fetchSaleTickets };
}
